/* eslint-disable react-hooks/exhaustive-deps */
import './styles.scss'
import React, { Fragment, useEffect, useState } from 'react'
import { Button, Col, Container, CustomInput, Form, FormGroup, Input, Label, Row } from 'reactstrap'
import { I18n } from 'react-redux-i18n'
import { connect, useSelector } from 'react-redux'
import { company } from '../../../../api'
import Nixi1Loading from '../../../../components/Nixi1Loading'
import InfoTooltip from '../../../../components/InfoTooltip'
import SelectorBrandDelegation from '../../../../components/SelectorBrandDelegation'
import { uploadFiles } from '../../../../utils'
import UploadFiles from '../../../../components/UploadFiles'
import FilePreview from '../../../../components/UploadFiles/FilePreview'
import ImageCropper from 'components/ImageCropper'

const { configurations: botManagementApi } = company

const BotConfiguration = (props) => {
  const { user, companies } = useSelector((state) => state)
  const [loading, setLoading] = useState(true)
  const [blockButton, setBlockButton] = useState(true)
  const [configuration, setConfiguration] = useState({
    companyName: '',
    companyTerms: '',
    companyUrl: '',
    companyLogo: '',
    specificIntents: false,
    redirections: false,
    // IA state
    isActiveCapstone: true,
    isActiveExtractor: true,
    users: {},
    operators: {},
  })
  const [uploadingFiles, setUploadingFiles] = useState(false)

  const handleUploadFile = async (files) => {
    try {
      setUploadingFiles(true)

      const {
        company: { type: companyType, hash: companyToken },
      } = props

      const attachments = await uploadFiles({
        files,
        typeUpload: 'userFile',
        companyType,
        companyToken,
      })

      if (attachments.length > 0) {
        handleSubmit(
          {
            preventDefault: () => { },
          },
          { ...configuration, companyLogo: attachments[0].urlLong || attachments[0].url }
        )
      }
    } catch (e) {
      console.error(e.message)
    } finally {
      setUploadingFiles(false)
    }
  }

  const handleGetConfiguration = (brand, delegation) => {
    setBlockButton(true)
    botManagementApi
      .getConfiguration(companies._id, { brand, delegation })
      .then(({ data, status }) => {
        if (status === 200) {
          setConfiguration(data.results)
          switch (user.role) {
            case 'owner':
            case 'admin':
            case 'root':
              setBlockButton(false)
              break
            case 'brandManager':
              if (brand) setBlockButton(false)
              break
            case 'delegationManager':
              if (delegation) setBlockButton(false)
              break
            default:
              setBlockButton(true)
          }
        }
      })
      .catch(console.error)
      .finally(() => setLoading(false))
  }

  const onRemoveFile = () => {
    handleSubmit(
      {
        preventDefault: () => { },
      },
      { ...configuration, companyLogo: '' }
    )
  }

  useEffect(() => {
    handleGetConfiguration()
  }, [])

  const handleSubmit = (e, data) => {
    e.preventDefault()
    setBlockButton(true)

    const newConfiguration = data || configuration
    let promise
    if (!newConfiguration._id) {
      promise = botManagementApi.postConfiguration(companies._id, newConfiguration)
    } else {
      promise = botManagementApi.updateConfiguration(companies._id, newConfiguration)
    }

    promise
      .then(({ data, status }) => {
        if (status === 200) {
          setConfiguration(data.results)
        }
      })
      .catch((err) => console.error('handleSubmit -> err', err))
      .finally(() => setBlockButton(false))
  }

  const isABigCompany = !props.company.pyme

  return (
    <Container fluid className='py-5 company-management animated fadeIn'>
      <Row>
        <Col>
          <h1>{I18n.t('dashboard_personalization')}</h1>
        </Col>
      </Row>
      {loading ? (
        <Nixi1Loading />
      ) : (
        <Fragment>
          {/* Bot Settings */}
          <Row className='mt-3'>
            <Col>
              <div className='section-subtitle'>{I18n.t('dashboard_company-information')}</div>
            </Col>
          </Row>
          {isABigCompany && (
            <Row className={'mt-3'}>
              <Col xs={8}>
                <SelectorBrandDelegation onChange={handleGetConfiguration} lockedButtons={blockButton} />
              </Col>
              <Col xs={4} />
            </Row>
          )}

          <Form onSubmit={handleSubmit}>
            <Row>
              <Col xs={4}>
                <FormGroup>
                  <Label htmlFor='companyLogo'>{I18n.t('dashboard_company-logo')}</Label>
                  <InfoTooltip targetId='companyLogo' text={I18n.t('dashboard_company-logo-info')} position='right' />
                </FormGroup>
              </Col>
              <Col xs={4}>
                {configuration.companyLogo ? (
                  <div style={{ alignItems: 'center', display: 'flex' }}>
                    <FilePreview
                      url={configuration.companyLogo || ''}
                      shortUrl={configuration.companyLogo || ''}
                      type='image/*'
                      onRemoveFile={onRemoveFile}
                    />
                    {configuration.companyLogo !== '' ?
                      <ImageCropper
                        imageUrl={configuration.companyLogo}
                        uploadFile={handleUploadFile}
                      /> : null
                    }
                  </div>
                ) : (
                  <UploadFiles
                    hidden={blockButton}
                    uploading={uploadingFiles}
                    uploadFiles={(files) => handleUploadFile(files)}
                    multiple={false}
                    cancelButton={false}
                    accept='image/*'
                  />
                )}
              </Col>
              <Col xs={4} />
            </Row>
            <Row className='mt-3'>
              <Col xs={4}>
                <FormGroup>
                  <Label htmlFor='companyName'>{I18n.t('dashboard_company-name')}</Label>
                  <InfoTooltip targetId='companyName' text={I18n.t('dashboard_company-name-bot-info')} position='right' />
                </FormGroup>
              </Col>
              <Col xs={4} className='text-right'>
                <FormGroup>
                  <Input
                    type='text'
                    name='companyName'
                    className='form-control'
                    value={configuration.companyName || ''}
                    onChange={(e) =>
                      setConfiguration({
                        ...configuration,
                        companyName: e.target.value,
                      })
                    }
                    disabled={blockButton}
                    required
                  />
                </FormGroup>
              </Col>
              <Col xs={4} />
            </Row>
            <Row className='mt-3'>
              <Col xs={4}>
                <FormGroup>
                  <Label htmlFor='companyUrl'>{I18n.t('dashboard_company-website')}</Label>
                  <InfoTooltip targetId='companyUrl' text={I18n.t('dashboard_company-website-info')} position='right' />
                </FormGroup>
              </Col>
              <Col xs={4} className='text-right'>
                <FormGroup>
                  <Input
                    type='text'
                    name='companyUrl'
                    className='form-control'
                    value={configuration.companyUrl || ''}
                    onChange={(e) =>
                      setConfiguration({
                        ...configuration,
                        companyUrl: e.target.value,
                      })
                    }
                    disabled={blockButton}
                    required
                  />
                </FormGroup>
              </Col>
              <Col xs={4} />
            </Row>
            <Row className='mt-3'>
              <Col xs={4}>
                <FormGroup>
                  <Label htmlFor='companyTerms'>{I18n.t('dashboard_terms-conditions-link')}</Label>
                </FormGroup>
              </Col>
              <Col xs={4} className='text-right'>
                <FormGroup>
                  <Input
                    type='url'
                    name='companyTerms'
                    className='form-control'
                    value={configuration.companyTerms || ''}
                    onChange={(e) =>
                      setConfiguration({
                        ...configuration,
                        companyTerms: e.target.value,
                      })
                    }
                    disabled={blockButton}
                    placeholder='e.g. https://www.terminosycondiciones.com'
                  />
                </FormGroup>
              </Col>
              <Col xs={4} />
            </Row>
            <Row className='mt-3'>
              <Col xs={4}>
                <FormGroup>
                  <Label htmlFor='privacyPolicies'>{I18n.t('dashboard_privacy-policy-link')}</Label>
                </FormGroup>
              </Col>
              <Col xs={4} className='text-right'>
                <FormGroup>
                  <Input
                    type='url'
                    name='privacyPolicies'
                    className='form-control'
                    value={configuration.privacyPolicies || ''}
                    onChange={(e) =>
                      setConfiguration({
                        ...configuration,
                        privacyPolicies: e.target.value,
                      })
                    }
                    disabled={blockButton}
                    placeholder='e.g. https://www.politicadeprivacidad.com'
                  />
                </FormGroup>
              </Col>
              <Col xs={4} />
            </Row>

            {/* Bot Settings */}
            <Row className='mt-3' hidden={props.company.type === 'OP'}>
              <Col>
                <FormGroup>
                  <div className='section-subtitle'>{I18n.t('dashboard_providers-redirection')}</div>
                </FormGroup>
              </Col>
            </Row>

            <Row hidden={props.company.type === 'OP'}>
              <Col xs={3}>
                <FormGroup>
                  <Label htmlFor='redirections'>{I18n.t('dashboard_redirect')}</Label>
                  <InfoTooltip targetId='redirections' text={I18n.t('dashboard_providers-redirect-info')} position='right' />
                </FormGroup>
              </Col>
              <Col xs={3} className='text-left'>
                <FormGroup>
                  <CustomInput
                    id='botManagement.redirections'
                    type='switch'
                    name='redirections'
                    checked={configuration.redirections}
                    value={configuration.redirections}
                    onChange={(e) =>
                      setConfiguration({
                        ...configuration,
                        [e.target.name]: e.target.checked,
                      })
                    }
                    disabled={blockButton}
                  />
                </FormGroup>
              </Col>
              <Col xs={6} />
            </Row>

            <Row className='mt-3' hidden={props.company.type === 'OP'}>
              <Col>
                <FormGroup>
                  <div className='section-subtitle'>{I18n.t('dashboard_chatbot')}</div>
                </FormGroup>
              </Col>
            </Row>

            <Row hidden={props.company.type === 'OP'}>
              <Col xs={3}>
                <FormGroup>
                  <Label htmlFor='transactionalInfo'>{I18n.t('dashboard_transactional')}</Label>
                  <InfoTooltip targetId='transactionalInfo' text={I18n.t('dashboard_transactional-bot-info')} position='right' />
                </FormGroup>
              </Col>
              <Col xs={3} className='text-left'>
                <FormGroup>
                  <CustomInput
                    type='switch'
                    id='botManagement.transactional'
                    name='isActiveCapstone'
                    checked={configuration.isActiveCapstone}
                    value={configuration.isActiveCapstone}
                    onChange={(e) =>
                      setConfiguration({
                        ...configuration,
                        [e.target.name]: e.target.checked,
                      })
                    }
                    disabled={blockButton}
                  />
                </FormGroup>
              </Col>
              <Col xs={6} />
            </Row>

            <Row hidden={props.company.type === 'OP'}>
              <Col xs={3}>
                <FormGroup>
                  <Label htmlFor='assistentialInfo'>{I18n.t('dashboard_assistential')}</Label>
                  <InfoTooltip targetId='assistentialInfo' text={I18n.t('dashboard_assistential-bot-info')} position='right' />
                </FormGroup>
              </Col>
              <Col xs={3} className='text-left'>
                <FormGroup>
                  <CustomInput
                    type='switch'
                    id='botManagement.assistential'
                    name='isActiveExtractor'
                    checked={configuration.isActiveExtractor}
                    value={configuration.isActiveExtractor}
                    onChange={(e) =>
                      setConfiguration({
                        ...configuration,
                        [e.target.name]: e.target.checked,
                      })
                    }
                    disabled={blockButton}
                  />
                </FormGroup>
              </Col>
              <Col xs={6} />
            </Row>

            <Row className={`mt-${props.company.type === 'OP' ? '2' : '5'}`}>
              <Col xs={6} />
              <Col xs={2} className='text-right'>
                <Button type='submit' disabled={blockButton} color='primary'>
                  {I18n.t('dashboard_save')}
                </Button>
              </Col>
              <Col xs={4} />
            </Row>
          </Form>
        </Fragment>
      )}
    </Container>
  )
}

export default connect((state) => ({ company: state.companies }))(BotConfiguration)
